export enum Status {
  loading,
  ready
}

export enum Mode {
  normal,
  extended
}